import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const AccessibilityContext = createContext(null);

const DEFAULTS = { fontSize: "normal", contrast: false, links: false, motion: false };

export const AccessibilityProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    try {
      return { ...DEFAULTS, ...JSON.parse(localStorage.getItem("cfm_a11y") || "{}") };
    } catch {
      return DEFAULTS;
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("a11y-font-large", settings.fontSize === "large");
    root.classList.toggle("a11y-font-xl", settings.fontSize === "xl");
    root.classList.toggle("a11y-contrast", settings.contrast);
    root.classList.toggle("a11y-links", settings.links);
    root.classList.toggle("a11y-no-motion", settings.motion);
    localStorage.setItem("cfm_a11y", JSON.stringify(settings));
  }, [settings]);

  const update = useCallback((patch) => setSettings((s) => ({ ...s, ...patch })), []);
  const reset = useCallback(() => setSettings(DEFAULTS), []);

  return (
    <AccessibilityContext.Provider value={{ settings, update, reset }}>
      {children}
    </AccessibilityContext.Provider>
  );
};

export const useA11y = () => {
  const ctx = useContext(AccessibilityContext);
  if (!ctx) throw new Error("useA11y must be used within AccessibilityProvider");
  return ctx;
};
